import states from '@/assets/states.json';

export const CANONICAL_STATES = states;

export function isCanonicalState(stateName) {
  return CANONICAL_STATES.includes(stateName);
}

export default CANONICAL_STATES;
